module.exports = require('./helpers/bundle-url').getBundleURL('aDgzp') + "logo.c51670a8.svg";